import { useTheme } from "simplydo/react/theme";

/**
 * Global theme leftovers after migrating UI components to simplydo/react/ui.
 * Button/Label/Modal chrome now lives in component styles. This file keeps:
 * - org font families
 * - link / primary-text colours
 * - mount-node overflow tweak
 */
const AppStyling = () => {
  const theme = useTheme();

  return (
    <style>
      {`
        body,
        h1,
        h2,
        h3,
        h4,
        h5,
        span,
        input,
        p {
          font-family: ${theme?.fontFamily?.body || "Inter"};
          -webkit-font-smoothing: antialiased;
        }
        h1 {
          font-family: ${theme?.fontFamily?.h1 || "Inter"};
        }
        h2 {
          font-family: ${theme?.fontFamily?.h2 || "Inter"};
        }
        h3 {
          font-family: ${theme?.fontFamily?.h3 || "Inter"};
        }
        h4 {
          font-family: ${theme?.fontFamily?.h4 || "Inter"};
        }
        h5 {
          font-family: ${theme?.fontFamily?.h5 || "Inter"};
        }

        .ui.active.modals.dimmer.visible .ui.basic.modal {
          --border-color: rgb(118 118 118 / 20%);

          background-color: rgb(0 0 0 / 20%) !important;
          border-radius: 6px !important;
          border: 1px solid var(--border-color) !important;
          box-shadow: 2px 4px 10px 0 rgba(0, 0, 0, 0.2) !important;
        }

        .ui.active.modals.dimmer.visible .ui.basic.modal .header {
          border-bottom: 1px solid var(--border-color) !important;
        }

        .ui.active.modals.dimmer.visible .ui.basic.modal .actions {
          border-top: 1px solid var(--border-color) !important;
        }

        .idea img {
          object-fit: contain;
          max-width: 100%;
        }

        #modal-mount-node.dimmed.dimmable {
          overflow: visible;
        }

        ${(() => {
          if (!theme) {
            return "";
          }

          const override = `

            a,a:hover{color:${theme.primaryColour}; text-decoration: none;}
            a.with-border{border-bottom:1px dotted ${theme.primaryColour};}
            .primary-text{color: ${theme.primaryColour};}
          `;

          return override;
        })()}
  `}
    </style>
  );
};

export default AppStyling;
